const updates = [
  {
    date: '07-30',
    title: '某顶流塌房事件最新进展：品牌方集体解约',
    summary: '继昨日事件发酵后，已有12家品牌宣布终止合作，涉及代言费总额超2亿元。',
    tag: '最新',
    tagColor: 'bg-primary-500 text-background-50',
  },
  {
    date: '07-29',
    title: '综艺录制现场突发冲突，导演与嘉宾激烈对峙',
    summary: '知情人士透露，冲突源于剪辑方向分歧，节目组已紧急调整后续录制计划。',
    tag: '独家',
    tagColor: 'bg-accent-500 text-background-50',
  },
  {
    date: '07-28',
    title: '网红直播带货数据造假被曝光，平台启动调查',
    summary: '第三方监测显示某头部网红直播间真实观众不足显示数据的15%，涉及刷量产业链。',
    tag: '实锤',
    tagColor: 'bg-primary-500 text-background-50',
  },
  {
    date: '07-27',
    title: '某艺人工作室发布律师函，否认全部指控',
    summary: '工作室声明称将追究造谣者法律责任，但未正面回应深扒文章中的关键时间节点。',
    tag: '',
    tagColor: '',
  },
  {
    date: '07-26',
    title: '音乐节主办方致歉：承认管控不力并公布整改方案',
    summary: '针对假唱风波和出场费纠纷，主办方承诺建立艺人演出质量监督机制。',
    tag: '',
    tagColor: '',
  },
  {
    date: '07-25',
    title: '饭圈互撕升级，多个后援会联合发声呼吁理性追星',
    summary: '事件波及多个明星超话，平台方已对恶意引战账号进行批量处理。',
    tag: '',
    tagColor: '',
  },
  {
    date: '07-24',
    title: '独家：某女星合约纠纷内幕曝光，原经纪公司涉嫌违规',
    summary: '合同条款显示存在多项不合理限制，法务专家解读艺人解约的法律路径。',
    tag: '独家',
    tagColor: 'bg-accent-500 text-background-50',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="scroll-mt-20 py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading">最新速报</h2>
          <p className="mt-2 text-sm text-foreground-500">24小时不间断追踪，大瓜第一时间送达</p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 before:absolute before:left-[15px] before:top-2 before:bottom-2 before:w-px before:bg-background-300">
            {updates.map((item, idx) => (
              <div key={idx} className="relative pb-6 last:pb-0">
                <div className="absolute left-[-32px] top-1 w-[14px] h-[14px] rounded-full bg-primary-500 border-2 border-background-50"></div>
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <span className="text-xs font-bold text-primary-500 font-heading whitespace-nowrap">{item.date}</span>
                  {item.tag && (
                    <span className={`text-[10px] px-1.5 py-0.5 rounded font-medium whitespace-nowrap ${item.tagColor}`}>
                      {item.tag}
                    </span>
                  )}
                </div>
                <h3 className="text-sm md:text-base font-bold text-foreground-900 font-heading mb-1">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.summary}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}